export default "__VITE_ASSET__a70232b7__"